'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var AnimateNumber = (_temp = _class = function (_PureComponent) {
    _inherits(AnimateNumber, _PureComponent);

    function AnimateNumber(props) {
        _classCallCheck(this, AnimateNumber);

        var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

        _this.clearAnimate = _this.clearAnimate.bind(_this);

        _this.state = {
            fromVal: props.value,
            toVal: null
        };
        return _this;
    }

    AnimateNumber.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        var nextProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        if (this.props.value === nextProps.value) {
            return;
        }
        if (!this.props.value && this.props.value !== 0) {
            this.setState({
                fromVal: nextProps.value,
                toVal: null
            });
            return;
        }
        this.setState({
            fromVal: this.props.value,
            toVal: nextProps.value
        });
    };

    AnimateNumber.prototype.clearAnimate = function clearAnimate() {
        this.setState({
            fromVal: this.props.value,
            toVal: null
        });
        this.props.onAnimated && this.props.onAnimated();
    };

    AnimateNumber.prototype.render = function render() {
        var _classNames;

        var _props = this.props,
            className = _props.className,
            duration = _props.duration,
            type = _props.type;
        var _state = this.state,
            fromVal = _state.fromVal,
            toVal = _state.toVal;

        var cls = (0, _classnames2['default'])((_classNames = {
            'animate-number': true
        }, _defineProperty(_classNames, 'animate-type-' + type, true), _defineProperty(_classNames, 'do-animate', toVal !== null), _defineProperty(_classNames, className, className), _classNames));
        var style = {
            transitionDuration: duration + 'ms'
        };

        return _react2['default'].createElement(
            'span',
            { className: cls },
            _react2['default'].createElement(
                'span',
                { className: 'animate-number-content', onTransitionEnd: this.clearAnimate, style: style },
                _react2['default'].createElement(
                    'span',
                    { className: 'from-num' },
                    fromVal
                ),
                toVal !== null && _react2['default'].createElement(
                    'span',
                    { className: 'to-num' },
                    toVal
                )
            )
        );
    };

    return AnimateNumber;
}(_react.PureComponent), _class.defaultProps = {
    type: 'scroll',
    duration: 800
}, _temp);
exports['default'] = AnimateNumber;
module.exports = exports['default'];